import { render, staticRenderFns } from "./ImportPurchaseForm.vue?vue&type=template&id=0b6939cd&scoped=true&"
import script from "./ImportPurchaseForm.vue?vue&type=script&lang=js&"
export * from "./ImportPurchaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6939cd",
  null
  
)

export default component.exports